<template>
	<form
		@submit.prevent="send"
		@keyup.enter="send"
		class="composer col-12 pl-0 pr-2"
		style="background: aliceblue"
		@mouseleave="showEmojiBox = false"
	>
		<div class="float-right pt-0">
			<i
				@click="showEmojiBox = !showEmojiBox"
				class="mdi mdi-emoticon-outline cursor-pointer"
			/>
			<Picker
				v-if="showEmojiBox"
				:data="emojiIndex"
				set="twitter"
				@select="showEmoji"
				:i18n="i18n"
				:style="{
					position: 'absolute',
					bottom: '100px',
					right: '10px',
				}"
			/>
		</div>
		<textarea
			style="height: 80%; resize: none"
			v-model="message"
			placeholder="Mensagem"
			class="form-control col-12"
			ref="textarea"
			@click="showEmojiBox = false"
			@keypress="$emit('writing')"
			@mouseleave="$emit('stop-writing')"
		/>
	</form>
</template>

<script>
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast";
let emojiIndex = new EmojiIndex(data);
export default {
	components: { Picker },
	data() {
		return {
			message: "",
			showEmojiBox: false,
			emojiIndex: emojiIndex,
			emojisOutput: "",

			i18n: {
				search: "Buscar",
				notfound: "Emoji não encontrado",
				categories: {
					search: "Procurar Resultados",
					recent: "Usado frequentemente",
					smileys: "Smileys e emoticon",
					people: "Pessoas e corpo",
					nature: "Animais e natureza",
					foods: "Comida e bebida",
					activity: "Atividade",
					places: "Viagem e lugares",
					objects: "Objetos",
					symbols: "Símbolos",
					flags: "Bandeiras",
					custom: "Personalizada",
				},
			},
		};
	},
	methods: {
		send() {
			this.message = this.message.replaceAll("\n", "");
			if (this.message != "" && this.message != "\n") {
				this.$emit("send", this.message);
				this.$emit("stop-writing");
				this.message = "";
			}
		},
		showEmoji(emoji) {
			let textarea = this.$refs.textarea;
			let cursorPosition = textarea.selectionStart;
			this.emojisOutput = emoji.native;

			this.message =
				this.message.substring(0, cursorPosition) +
				this.emojisOutput +
				this.message.substring(cursorPosition, this.message.length);
		},
	},
};
</script>

<style lang="scss" scoped>
.composer {
	height: 20%;
	// position: absolute;
	// width: 100%;
}
</style>
